import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "add-role-modal" }
const _hoisted_2 = { class: "add-role-modal__search" }
const _hoisted_3 = {
  key: 0,
  class: "add-role-modal__close"
}
const _hoisted_4 = { class: "add-role-modal__header" }
const _hoisted_5 = { class: "add-role-modal__header-title" }
const _hoisted_6 = ["onClick"]

import {
	computed,
	nextTick,
	onMounted,
	ref
} from "vue";
import AppCheckbox from "@/components/ui-kit/checkbox/AppCheckbox.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { WorkerApi } from "@/ api/WorkerApi";
import { CommonEntityRecord } from "@/models/interfaces/common";
import { clientPageStore } from "@/store/client-page";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientAddRoleDropdown',
  props: {
    clientId: {},
    workerId: {},
    attachedRoles: {},
    showCloseIcon: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const $input = ref<typeof AppInput | null>(null)
const $body = ref<HTMLDivElement | null>(null)

const store = clientPageStore()

const isLoading = ref(true)
const filter = ref('')
const roles = ref<CommonEntityRecord[]>([])

const addedIds = computed(() => new Set((props.attachedRoles || []).map(r => r.Id)))

const filteredRoles = computed<CommonEntityRecord[]>(() => {
	const query = filter.value.trim().toLowerCase()
	if (!query) return roles.value
	return roles.value.filter(r => r.Name?.toLowerCase().includes(query))
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const onFetchRoles = async () => {
	try {
		isLoading.value = true
		roles.value = await WorkerApi.getWorkerRoles(props.clientId, props.workerId)
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false
	}
}

const isRoleAdded = (roleId: number) => addedIds.value.has(roleId)

const onAttach = async (role: CommonEntityRecord) => {
	try {
		isLoading.value = true
		await store.attachRoleToWorker(props.workerId, { Id: role.Id, Name: role.Name })
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false
	}
}

const onDetach = async (roleId: number) => {
	try {
		isLoading.value = true
		await store.detachRoleFromWorker(props.workerId, roleId)
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false
	}
}

const onChangeRoleStage = async (stage: boolean, role: CommonEntityRecord) => {
	if (stage) {
		await onAttach(role)
	} else {
		await onDetach(role.Id)
	}
}

const onChangeRoleStageFromName = async (role: CommonEntityRecord) => {
	if (isRoleAdded(role.Id)) {
		await onDetach(role.Id)
	} else {
		await onAttach(role)
	}
}

onMounted(async () => {
	await onFetchRoles()
	await nextTick(() => $input.value?.focusInput())
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppInput, {
        ref_key: "$input",
        ref: $input,
        modelValue: filter.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
        class: "add-role-modal__search-input",
        placeholder: _ctx.$t('search_short')
      }, null, 8, ["modelValue", "placeholder"]),
      (props.showCloseIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(AppTooltip, {
              text: _ctx.$t('close_label')
            }, {
              activator: _withCtx(() => [
                _createVNode(AppIcon, {
                  name: "close",
                  width: "20px",
                  color: "#D2D2D2",
                  "hover-color": "#499259",
                  cursor: "pointer",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
                })
              ]),
              _: 1
            }, 8, ["text"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('roles_label')), 1)
    ]),
    _createElementVNode("div", {
      class: "add-role-modal__body",
      ref_key: "$body",
      ref: $body
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRoles.value, (role) => {
        return (_openBlock(), _createElementBlock("div", {
          key: role.Id,
          class: "add-role-modal__body-item"
        }, [
          _createVNode(AppCheckbox, {
            style: { height: '16px', marginRight: '8px' },
            value: isRoleAdded(role.Id),
            text: "",
            onInput: ($event: any) => (onChangeRoleStage($event, role))
          }, null, 8, ["value", "onInput"]),
          _createElementVNode("div", {
            class: "add-role-modal__body-item-text",
            onClick: ($event: any) => (onChangeRoleStageFromName(role))
          }, _toDisplayString(role.Name), 9, _hoisted_6)
        ]))
      }), 128))
    ], 512)
  ]))
}
}

})